import backToTop from './_webpack/backToTop.js'
import sticky from './_webpack/sticky.js'
import scrollToAnchor from './_webpack/scrollToAnchor.js'
import transferValue from './_webpack/transferValue.js'
import popUp from './_webpack/popUp.js'
import inputMask from './_webpack/inputMask.js'
import auth from './_webpack/auth.js'
import form from './_webpack/form.js'
import isIE from './_webpack/isIE.js'
import isMobile from './_webpack/isMobile.js'

// Стартует до загрузки DOM
isIE()

// activate(). Начало работы после полной загрузки DOM
window.addEventListener('load', function () {
  if (document.querySelector('.js-pop-up')) {
    isMobile()
  }
  if (document.querySelector('.js-pop-up')) {
    popUp()
  }
  if (document.querySelector('.js-sticky')) {
    sticky()
  }
  if (document.querySelector('a[href^="#anchor-"]')) {
    scrollToAnchor()
  }
  if (document.querySelector('[type="tel"]')) {
    inputMask()
  }
  if (document.querySelector('.js-back-to-top')) {
    backToTop()
  }
  if (document.querySelector('.js-auth')) {
    auth()
  }
  if (document.querySelector('form')) {
    form()
  }
  if (document.querySelector('.js-transfer-value')) {
    transferValue()
  }
})
